import styled from 'styled-components';

export const Avatar = styled.img`
  border-radius: 50%;
`;

export const AvatarContainer = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  margin-left: auto;
  margin-right: auto;
`;
